import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ListItemButton, ListItemIcon, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  SettingsIconAlt,
  AnalyticsIconAlt,
  CandidateIconAlt,
  HomeIconAlt,
  JobsIconAlt,
  MailIconAlt,
  PeopleIconAlt,
  VendorsIconAlt,
} from 'wisestep-base';

const useStyles = makeStyles({
  mainOption: {
    '& span, & svg': {
      fontSize: '0.9rem',
    },
  },
  secondaryOption: {
    '& span, & svg': {
      fontSize: '0.8rem',
      color: '#888888',
    },
    paddingLeft: '30%',
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#F8F8F8',
    },
  },
});

const sidebarMenuItems = [
  {
    name: 'Home',
    link: '/',
    icon: HomeIconAlt,
    items: [],
  },
  {
    name: 'Job',
    link: '/jobs/',
    icon: JobsIconAlt,
    items: [
      {
        name: 'Jobs List',
        link: '/jobs/',
      },
      {
        name: 'Post New Job',
        link: '/jobs/new',
      },
      {
        name: 'Hot Jobs for Bench Consultants',
        link: '/',
      },
    ],
  },
  {
    name: 'Candidates',
    link: '/candidates',
    icon: CandidateIconAlt,
    items: [
      {
        name: 'Talent Pool',
        link: '/candidates',
      },
      {
        name: 'Mappings',
        link: '/candidates/mappings',
      },
      {
        name: 'Submissions',
        link: '/submissions',
      },
      {
        name: 'Import Candidates',
        link: '/import-candidates',
      },
      {
        name: 'Harvesting Bots',
        link: '/',
      },
      {
        name: 'Active Consultants',
        link: '/active-consultants',
      },
    ],
  },
  {
    name: 'Vendor List',
    link: '/vendors',
    icon: VendorsIconAlt,
    items: [],
  },
  {
    name: 'Analytics',
    link: '/analytics/',
    icon: AnalyticsIconAlt,
    items: [],
  },
  {
    name: 'People',
    link: '/people',
    icon: PeopleIconAlt,
    items: [],
  },
  {
    name: 'Mail',
    link: '/email-settings/logs/inbox/',
    icon: MailIconAlt,
    items: [],
  },
  {
    name: 'Settings',
    link: '/app-settings/teams-and-users',
    icon: SettingsIconAlt,
    items: [],
  },
];

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

interface SideMenuProps {
  open: boolean;
  sideMenuClose(): void;
}

export default function SideBar(props: SideMenuProps) {
  const classes = useStyles();

  const { open, sideMenuClose } = props;

  const handleDrawerClose = () => sideMenuClose();
  const list = () => (
    <Box role="presentation" onClick={handleDrawerClose} onKeyDown={handleDrawerClose}>
      <List>
        {sidebarMenuItems.map((item, index) => (
          <>
            <ListItem
              button
              key={index}
              to={item.link}
              component={Link}
              className={classes.listItem}
            >
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
              <ListItemText className={classes.mainOption} primary={item.name} />
            </ListItem>
            {item.items.map((subItem, subIndex) => (
              <List disablePadding key={subIndex}>
                <ListItemButton
                  style={{ paddingTop: '0px', paddingBottom: '0px' }}
                  component={Link}
                  to={subItem.link}
                >
                  <ListItemText className={classes.secondaryOption} primary={subItem.name} />
                </ListItemButton>
              </List>
            ))}
          </>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <Box sx={{ position: 'fixed' }}>
      {
        <Fragment key={'left'}>
          <List>
            {sidebarMenuItems.map((item, index) => (
              <ListItem key={index} className={classes.listItem} to={item.link} component={Link}>
                <Tooltip title={item.name}>
                  <ListItemIcon>
                    <item.icon />
                  </ListItemIcon>
                </Tooltip>
              </ListItem>
            ))}
          </List>
          <Drawer anchor="left" open={open} onClose={handleDrawerClose}>
            <DrawerHeader>
              <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            </DrawerHeader>
            {list()}
          </Drawer>
        </Fragment>
      }
    </Box>
  );
}
